import { Button, ButtonGroup, H3, Stack, Text } from "@adfenix/alexandria";
import cx from "classnames";
import PageItem from "./PageItem";
import NotSeeingTheRightPagesInfo from "./NotSeeingTheRightPagesInfo";
import { PageInfo, State } from "./interfaces";
import { StyledLevel, StyledLevelItem } from "./StyledElements";
import { useTranslation } from "react-i18next";
const OnePage = ({
  page,
  setActiveState,
  saveSetting,
  isLoadingUpdate
}: {
  page: PageInfo;
  setActiveState: (state: State) => void;
  saveSetting: (pageId: string) => Promise<void>;
  isLoadingUpdate: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <Stack spacing="l">
      <H3 style={{ marginBottom: 8 }}>{t("selfonboarding.onePage.header")}</H3>
      <Text>{t("selfonboarding.onePage.description")}</Text>

      <StyledLevel>
        <StyledLevelItem style={{ marginTop: 16 }} className={cx("checked")}>
          <PageItem
            pageData={{
              facebook: {
                facebookPageName: page.facebook.facebookPageName,
                facebookPageUrl: page.facebook.facebookPageUrl,
                facebookProfilePicture: page.facebook.facebookProfilePicture,
                accessToken: page.facebook.accessToken,
                facebookPageId: page.facebook.facebookPageId
              },
              instagram: {
                instagramAccountName: page.instagram?.instagramAccountName,
                instagramActorId: page.instagram?.instagramActorId,
                instagramProfilePicture: page.instagram?.instagramProfilePicture
              }
            }}
          />
        </StyledLevelItem>
      </StyledLevel>

      <NotSeeingTheRightPagesInfo />

      <ButtonGroup>
        <Button
          logLabel="selfonboarding-onepage-confirm-button"
          type="button"
          isLoading={isLoadingUpdate}
          onClick={() => saveSetting(page.facebook.facebookPageId)}
        >
          {t("selfonboarding.onePage.confirm.button")}
        </Button>
        <Button
          logLabel="selfonboarding-onepage-cancel-button"
          type="button"
          variant="secondary"
          onClick={() => setActiveState("loading")}
        >
          {t("selfonboarding.pickaPage.cancel.button")}
        </Button>
      </ButtonGroup>
    </Stack>
  );
};

export default OnePage;
